<template>
  <div class="settle_history_page">
    <div class="page-title">交易记录</div>
    <div class="page_search">
      <DatePicker
        v-model="searchDate"
        ref="searchInput"
        :type="searchDateType"
        :editable="false"
        :clearable="false"
        placeholder="请选择"
        style="width: 156px"
        :options="monthOpts"
      ></DatePicker>
      <span class="search_btn" @click="searchFn" >查询</span>
    </div>

    <pageTable
      :loading="tableLoading"
      :col="col"
      :data="tableData"
      :showPage="false"
      :isVerticalResize="false"
    ></pageTable>
  </div>
</template>
<script>
import { dateObjToStr } from '@/utils/common'
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import { getBillInfo } from '@/api/newagent.js'
export default {
  name: 'settlehistory',
  components: { pageTable },
  mixins: [pageTableMixin],
  data() {
    return {
      searchDate: '',
      searchDateType: 'month',
      monthOpts: {
        disabledDate(date) {
          var now = new Date()
          return date.getFullYear() < 2018 || date.getFullYear() > now.getFullYear() || (date.getFullYear() === now.getFullYear() && date.getMonth() > now.getMonth())
        }
      },
      col: [
        { field: 'use_time', title: '使用时间', width: 120, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'is_use_text', title: '状态', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true,
          formatter(rowData, pIndex, index, field) {
            if (rowData[field] === '已使用') {
              return '<span style="color:#2BB968;">已使用</span>'
            } else {
              return rowData[field]
            }
          }
        },
        { field: 'cust_no', title: '企业编码', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'company_type', title: '类型', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'cust_name', title: '企业名称', width: 120, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'tool_name_text', title: '工具名称', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'tool_time_length', title: '时间', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'card_no_confound', title: '卡号', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'card_pwd_confound', title: '卡密 ', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true }
      ]
    }
  },
  mounted() {
    document.querySelector('.normal-right-inner-wrap').addEventListener('scroll', this.slidSearch)
  },
  methods: {
    slidSearch() {
      this.$refs.searchInput.visible = false
    },
    initPage() {
      this.searchDate = new Date()
    },
    getData() {
      const fullDate = dateObjToStr(this.searchDate).replace(/\-/g, '').split(' ')[0].substring(0, 6)
      this.tableLoading = true
      getBillInfo({
        month_date: fullDate.substring(0, 4) + '-' + fullDate.substring(4, 6)
      }).then(res => {
        this.tableLoading = false
        if (res.code === 0) {
          this.tableData = res.result
        } else {
          this.tableData = []
        }
      })
    },
    searchFn() {
      this.getData()
    }
  },
  beforeDestroy() {
    document.querySelector('.normal-right-inner-wrap').removeEventListener('scroll', this.slidSearch)
  }
}
</script>
<style lang="scss" scoped>
.page_search {
  margin-bottom: 20px;
}
.search_btn {
  margin-left: 20px;
  width: 58px;
  height: 28px;
  line-height: 28px;
  border-radius: 2px;
  // opacity: .8;
  font-size: 12px;
  background-color: #1881dc;
  border-color: #1881dc;
  -webkit-transition: all .2s;
  transition: all .2s;
  color: #FFF;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
}
</style>
